import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LogIn } from "lucide-react";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Error inesperado. Inténtelo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  return String(detail);
}

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split">
      <div className="login-form-side" data-testid="login-form-side">
        <div className="max-w-sm w-full mx-auto">
          <div className="mb-10">
            <h1 className="text-4xl font-black tracking-tight text-[#002FA7]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              GarajeFact
            </h1>
            <p className="text-sm text-gray-500 mt-2">Gestion de facturas de plazas de garaje</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm" data-testid="login-error">
                {error}
              </div>
            )}
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-gray-900 mb-1 block">
                Correo electrónico
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@garaje.com"
                required
                className="border-gray-200 rounded-sm focus:ring-2 focus:ring-[#002FA7]"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-gray-900 mb-1 block">
                Contraseña
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Introduce tu contraseña"
                required
                className="border-gray-200 rounded-sm focus:ring-2 focus:ring-[#002FA7]"
                data-testid="login-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#002FA7] text-white hover:bg-[#00227B] rounded-sm py-2.5 text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="login-submit-button"
            >
              <LogIn className="w-4 h-4" />
              {loading ? "Iniciando sesion..." : "Iniciar sesion"}
            </button>
          </form>
        </div>
      </div>
      <div className="login-image-side">
        <img
          src="https://images.unsplash.com/photo-1664813953289-7c3350f040e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwd2hpdGV8ZW58MHx8fHwxNzc2MjY3ODUzfDA&ixlib=rb-4.1.0&q=85"
          alt="Arquitectura moderna"
        />
        <div className="absolute inset-0 bg-[#002FA7]/10" />
      </div>
    </div>
  );
}
